// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"n2-z","dimensionLabel":"o2-z","styleChooserControlWrapper":"p2-z","styleChooserControl":"q2-z","disabled":"r2-z","giftCard":"s2-z","styleChooserText":"t2-z"};